import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormValidationsService } from 'app/shared/form-validations/services/form-validations.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { OwnValidators } from 'app/shared/validators/global';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {

  constructor(private _appAuthService: AppAuthService, private formValidationsService: FormValidationsService, 
    private messagesService: AdvMessageService, private _localizationService: LocalizationService,private _cdr:ChangeDetectorRef) { }

    changePasswordForm: FormGroup;
    displayPasswordDialog: boolean = false;
    @Input() hasPassword:boolean;
    @Output() login: EventEmitter<any> = new EventEmitter<any>();
    @Output() passwordUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

    showFields: boolean = true;
    ngOnInit(): void {
      this.initForm();
    }
    
    showChangePasswordDialog() {
      this.initForm();
      this.showFields=true
      this.displayPasswordDialog = true;
    }
    
    changePassword() {
      if (this.changePasswordForm.valid) {
        if(this.hasPassword)
      { 
         this._appAuthService.changePassword(this.changePasswordForm.value).subscribe((res: any) => {
          if (res.Status==6) {
            this.messagesService.successMessage(this._localizationService.Translate("LOGIN.MESSAGES.CHANGE_PASSWORD_SUCCEEDED"));
            this.hasPassword=true;
            this.displayPasswordDialog = false; 
            this._cdr.detectChanges();
          }
           else if(res.Status==2){
            this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.PASSWORD.MESSAGES.MANAGER_NOT_FOUND"))
           }
           else if(res.Status==5)
           {
            this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.PASSWORD.MESSAGES.INVALID_CURRENT_PASSWORD"))
           }
           else{
            this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.MESSAGES.CHANGE_PASSWORD_FAILED"))
           }
        });
      }
      else{
         this._appAuthService.updatePassword(this.changePasswordForm.value).subscribe((res:any)=>{
          if (res.Status==6) {
            this.messagesService.successMessage(this._localizationService.Translate("LOGIN.MESSAGES.SET_PASSWORD_SUCCESS"));
            this.displayPasswordDialog = false; 
            this.hasPassword=true
            this.passwordUpdated.emit(true);
            this._cdr.detectChanges()
          }
          else if(res.Status==2){
            this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.PASSWORD.MESSAGES.MANAGER_NOT_FOUND"))
           }
           else{
            this.messagesService.errorMessage(this._localizationService.Translate("LOGIN.MESSAGES.CHANGE_PASSWORD_FAILED"))
           }
         })
      }
      } else {
        this.formValidationsService.markFormGroupTouched(this.changePasswordForm); 
      }
    }
    
    cancelChangePassword() {
      this.changePasswordForm.reset();
      this.showFields=false 
      this.displayPasswordDialog = false;  
    }
    
   private initForm() {
  if (this.hasPassword) {
    this.changePasswordForm = new FormGroup(
      {
        Password: new FormControl('', [Validators.required]), 
        NewPassword: new FormControl('', [Validators.required]), 
        PasswordConfirm: new FormControl('', [Validators.required]) 
      },
      { validators: this.passwordsMatchValidator } 
    );
  } else {
    this.changePasswordForm = new FormGroup(
      {
        NewPassword: new FormControl('', [Validators.required]), 
        PasswordConfirm: new FormControl('', [Validators.required])
      },
      { validators: this.passwordsMatchValidator }
    );
  }
}
    
    private passwordsMatchValidator(formGroup: AbstractControl) {
      const newPassword = formGroup.get('NewPassword')?.value;
      const passwordConfirm = formGroup.get('PasswordConfirm')?.value;
      return newPassword === passwordConfirm ? null : { passwordMismatch: true };
    }
    

}
